export class ErrorMarker {
  draw = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number
  ) => {
    c.save()
    c.strokeStyle = '#f21'
    c.lineWidth = 1
    // c.clearRect(x, y, w, h)
    c.strokeRect(
      x,
      y,
      w,
      h
    )
    c.restore()
  }
}
